import { green, red, yellow } from "@mui/material/colors";

export const warningYellow = yellow["800"];
export const successGreen = green["600"];
export const missingGrey = "#676767";
export const dangerRed = red["800"];
